import type { Position } from '../../../types/project';

export const isSearchStarted = (position: Position): boolean => {
    if (position.id.startsWith('local:')) return false;

    return (
        Boolean(position.searchStatus) ||
        (position.offers?.length ?? position.offersCount ?? 0) > 0 ||
        Boolean(position.avgFoundPrice)
    );
};